import React, { createContext, useEffect, useState, useMemo, useCallback } from 'react';
import { theDarkTheme, theLightTheme } from '../theme/theme';

export const ThemeContext = createContext();

function ThemeContextProvider(props) {
    const [theme, setTheme] = useState(theLightTheme);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isDark, setDark] = useState(false);

    const setHandleDrawer = useCallback(() => {
        setDrawerOpen((prevOpen) => !prevOpen);
    }, []);
    
    useEffect(() => {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            setTheme(theDarkTheme);
            setDark(true);
        } else {
            setTheme(theLightTheme);
            setDark(false);
        }
    }, []);

    const changeTheme = useCallback(() => {
        setDark((prevDark) => {
            const nextDark = !prevDark;
            setTheme(nextDark ? theDarkTheme : theLightTheme);
            return nextDark;
        });
    }, []);

    const value = useMemo(() => ({
        theme, 
        drawerOpen, 
        setHandleDrawer, 
        changeTheme, 
        isDark 
    }), [theme, drawerOpen, setHandleDrawer, changeTheme, isDark]);

    return (
        <ThemeContext.Provider value={value}>
            {props.children}
        </ThemeContext.Provider>
    );
}

export default ThemeContextProvider;